import { Component, EventEmitter, Output } from '@angular/core';
import { ChatService } from '../chat.service';

@Component({
  selector: 'app-chat-emote-list',
  templateUrl: './chat-emote-list.component.html',
  styleUrls: ['./chat-emote-list.component.scss'],
})
export class ChatEmoteListComponent {
  @Output() emoteSelected = new EventEmitter();

  emotes: string[] = ['steve'];

  constructor(public chatService: ChatService) {}

  onEmoteClick(emote: string) {
    this.emoteSelected.emit(emote);
  }
}
